import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { Corso } from '../../model/corso';
import { CourseService } from '../../service/course.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    corsi: Array<Corso>;

    constructor(
        private courseSrv: CourseService
    ) { }

    ngOnInit() {
        this.loadCorsi();
    }

    private loadCorsi() {
        this.courseSrv.getCoursesByUser()
        .pipe(first())
            .subscribe(
                data => {
                    this.corsi = data;
                },
                error => {
                    return;
                }
            );
    }

}
